export class IcebergTableColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "required",
            "baseName": "required",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "partition",
            "baseName": "partition",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "partitionTransform",
            "baseName": "partitionTransform",
            "type": "string",
            "format": ""
        },
        {
            "name": "doc",
            "baseName": "doc",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IcebergTableColumn.attributeTypeMap;
    }
    constructor() {
    }
}
